import React from "react";

const CostSalesForList = ({ value, baseCurrencyFormat }: { value: server.dto.MoneyWithExchangeRate, baseCurrencyFormat: "visible" | "hidden" }) => {
  if (value == null || value.amount === 0) {
    return null;
  }

  const showBaseCurrency = value.exchangeRate !== 1;

  if (baseCurrencyFormat === "hidden") {
    const title = showBaseCurrency ? value.formattedBaseCurrencyAmount : null;
    return <div title={title}>
      {value.formatted}
    </div>;
  }

  if (baseCurrencyFormat === "visible") {
    return <>
      <div>{value.formatted}</div>
      {showBaseCurrency && <div className="text-sublabel" title={value.formattedExchangeRate}>
        {value.formattedBaseCurrencyAmount}
      </div>}
    </>;
  }
};

export default CostSalesForList;